import React, { useState, useEffect, useContext } from "react";
import ReactPlayer from "react-player";
import { useUserAuth } from "../../context/UserAuthContext";
import Context from "../../context/Context";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "./HowToParticipate.module.css";
import bullet from "../../assests/bullet.svg";
import back from "../../assests/back.svg";
import forward from "../../assests/forward.svg";

const HowToParticipate = ({
  setParticipate,
  contestRules,
  contestDetails,
  setshowVoucher,
  setMultipleEntryPopup,
  contestClosed,
}) => {
  const navigate = useNavigate();
  const [participateLoading, setParticipateLoading] = useState(false);
  const organizerName_fromURL = window.location.href.split("/")[3];
  const {
    campaignClosed,
    isPrivate,
    setPinData,
    userIdToken,
    campaignEntryClosed,
  } = useContext(Context);
  const { setPreviousLocation, currentUser, guestModeEnabled } = useUserAuth();
  const location = useLocation();

  const orgId = contestDetails?.orgId;
  const cmpId = contestDetails?.campaignId;
  const ctstId = contestDetails?.contestId;
  const token = userIdToken || currentUser?.accessToken;
  useEffect(() => {
    window.scroll(0, 0);
  }, [setParticipate]);
  const handleParticipate = () => {
    if (isPrivate) {
      setshowVoucher(true);
    } else {
      verifyVoucher();
    }
  };
  const verifyVoucher = async () => {
    try {
      setParticipateLoading(true);
      let config = {
        method: "post",
        url: `${process.env.REACT_APP_SIGNEDURL}/${orgId}/${cmpId}/${ctstId}?orgDomain=${organizerName_fromURL}`,
        // url: `${process.env.REACT_APP_SIGNEDURL}/4/4/1`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
      const response = await axios(config);
      if (response.data.data.multipleEntriesFound) {
        setMultipleEntryPopup(true);
        setshowVoucher(false);
        setParticipate(false);
      } else {
        if (response.data.data.isVoucherValid && response.status === 201) {
          setPinData(response);
          setParticipateLoading(false);
          navigate("participate");
        } else if (!response.data.data.isVoucherValid) {
          setParticipateLoading(false);
          navigate("participate/error");
        }
      }
    } catch (error) {
      setParticipateLoading(false);
      navigate("participate/error");
    }
  };
  // console.log(details)
  return (
    <div className="">
      <div className=" z-100 w-[100%] md:w-[390px] h-[100%] bg-[#171717] flex flex-col items-center  min-h-[100vh]">
        <div className="w-[100%] flex justify-between px-[10px] ">
          <div
            className="w-[50px] h-[50px] bg-[#252525] mt-[13px] rounded-full flex items-center justify-center "
            onClick={() => {
              setParticipate(false);
            }}
          >
            <img src={back} alt="" />
          </div>
          {!campaignClosed &&
            !campaignEntryClosed &&
            !contestClosed &&
            (participateLoading ? (
              <div
                style={{ backgroundColor: contestDetails?.buttonColor }}
                className="h-[54px] w-[185px] mt-[13px]   rounded-full flex items-center justify-center cursor-pointer "
              >
                <span className="text-[17px] font-semibold flex items-center justify-center ">
                  Loading{" "}
                </span>
                <img
                  src={forward}
                  alt="arrow"
                  className="w-[26px] h-[12px] ml-[10px]"
                />
              </div>
            ) : guestModeEnabled ? (
              <div
                style={{ backgroundColor: contestDetails?.buttonColor }}
                className="h-[54px] w-[185px] mt-[13px] rounded-full flex items-center justify-center cursor-pointer "
                onClick={() => {
                  setPreviousLocation(window.location.pathname);
                  navigate(`/signup`, {
                    state: { previousLocation: location?.pathname },
                  });
                }}
              >
                <span className="font-[17px] font-semibold flex items-center justify-center ">
                  Log in to Participate
                </span>
              </div>
            ) : (
              <div
                style={{ backgroundColor: contestDetails?.buttonColor }}
                className="h-[54px] w-[185px] mt-[13px] rounded-full flex items-center justify-center cursor-pointer "
                onClick={() => {
                  setPreviousLocation(window.location.pathname);
                  handleParticipate();
                }}
              >
                <span className="font-[17px] font-semibold flex items-center justify-center ">
                  Participate{" "}
                </span>
                <img
                  src={forward}
                  alt="arrow"
                  className="w-[26px] h-[12px] ml-[10px]"
                />
              </div>
            ))}
        </div>

        <div className="mt-[24px]">
          <span className="ml-[16px]  font-semibold text-[21px]">
            {contestRules?.tagName}
          </span>
          <div className="mt-[30px]">
            {/* <span className='ml-[16px] text-[17px]'>Story</span> */}
            {contestRules?.Story?.fileUrl && (
              <div className="w-[390px] h-[205px] bg-[#252525] flex items-center justify-center mt-[10px]">
                <ReactPlayer
                  config={{
                    file: { attributes: { controlsList: "nodownload" } },
                  }}
                  playing={false}
                  controls={true}
                  width="100%"
                  height="200px"
                  url={contestRules?.Story?.fileUrl}
                  className="file"
                />
              </div>
            )}
          </div>
          {/* <div className='mt-[20px]'>
            <span className='ml-[16px] text-[17px]'>Rules</span>
            <div className='w-[390px] h-[205px] bg-[#252525] flex items-center justify-center mt-[10px]'>
              <ReactPlayer
                config={{ file: { attributes: { controlsList: 'nodownload' } } }}
                playing={false}
                controls={true}
                width="100%"
                height="200px"
                url={contestRules?.Rules?.fileUrl}
                className="file"
              />
            </div>
          </div> */}
        </div>

        <div className="w-[100%] mt-[30px] pr-[40px] pb-[20px]">
          <span className="text-[21px] font-semibold ml-[16px]">
            Contest Rules
          </span>

          {contestRules &&
            contestRules["Contest Rules"].map((rules) => (
              <div className="flex mt-[20px] text-[17px] items-center ">
                <img
                  src={bullet}
                  alt=""
                  className="w-[6px] h-[6px] mr-[23px] ml-[19px]"
                />
                <p className={styles.paragraph}>{rules.rule}</p>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default HowToParticipate;
